import { siteDevelopmentUrl } from "../../utility/Index";

export const accountManagementData = {
  AccountManagement: {
    Title: "Account management",
    GeneralTopData: [
      "Managing your account on ESQUADIFI is simple and secure. Here’s how to handle all aspects of your account, profile, and interactions with other users:",
    ],
    GeneralBottomData: [
      "For further help, use the Contact Us messaging feature within the platform",
    ],
    Steps: [
      {
        StepTitle: "Updating Your Profile",
        Description: [
          `Update profile: Go to the homepage, click “settings” go to <a href='${siteDevelopmentUrl}/webSetting?tab=account'>Account</a> and update profile.`,
        ],
      },
      {
        StepTitle: "Changing Password",
        Description: [
          `<a href='${siteDevelopmentUrl}/webSetting?tab=changePassword'>Change Password</a>: Access 'Account Settings' to securely update your password.`,
        ],
      },
      {
        StepTitle: "Managing Your Subscription",
        Description: [
          `<a href='${siteDevelopmentUrl}/webSetting?tab=subscription'>Manage Subscription</a>: View or update your subscription plan, change payment methods, or cancel your subscription under 'Subscription' settings.`,
        ],
      },
      {
        StepTitle: "Blocking, Reporting, and Unblocking Users",
        Description: [
          `<a href='${siteDevelopmentUrl}/webSetting?tab=blockReportUsers'>Block User</a>: To block a user, go to their profile and select the 'Block' option.`,
          "Unblock User: Go to your blocked users list in 'Settings' and select 'Unblock' for the user in question.",
          "Report Inappropriate Behavior: If a user is violating the platform's guidelines, go to their profile and select 'Report.' Provide details and submit.",
        ],
      },
      {
        StepTitle: "Deactivating or Deleting Your Account",
        Description: [
          `<a href='${siteDevelopmentUrl}/webSetting?tab=deactivate'>Deactivate Account</a>: Temporarily disable your account in the 'Account Settings' section. Your account can be reactivated at any time.`,
          `<a href='${siteDevelopmentUrl}/webSetting?tab=deactivate'>Delete Account</a>: Permanently delete your account in 'Account Settings.' This action is irreversible.`,
        ],
      },
    ],
  },
};
